import styled from "styled-components";
import { flexCenter } from "../../styles";
import { fontSize_SM, fontSize_XXL } from "../../customFonts";

export const FooterSection = styled.div`
  width: 100%;
  background: linear-gradient(135deg, #0f1419 0%, #1a1f2e 50%, #16191b 100%);
  color: white;
  padding: 60px 0 40px 0;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, #146ad3, transparent);
  }

  .container {
    position: relative;
    z-index: 2;
  }

  .logo {
    max-width: 180px;
    height: auto;
    filter: brightness(1.1);
    transition: all 0.3s ease;

    &:hover {
      filter: brightness(1.3) drop-shadow(0 0 10px rgba(20, 106, 211, 0.3));
    }
  }

  h5 {
    padding-bottom: 20px;
    font-weight: 600;
    ${fontSize_XXL};
    color: #ffffff;
    position: relative;
    margin-bottom: 25px;

    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 40px;
      height: 2px;
      background: linear-gradient(90deg, #146ad3, #e8292e);
      border-radius: 1px;
    }
  }

  ul {
    list-style: none;
    padding-left: 0;
    margin: 0;

    li {
      padding-bottom: 12px;
      transition: all 0.3s ease;

      &:hover {
        transform: translateX(5px);
      }
    }
  }

  p {
    font-weight: 400;
    ${fontSize_SM};
    line-height: 1.6;
    color: #b8bcc8;
    margin-bottom: 0;
  }

  li {
    font-weight: 400;
    ${fontSize_SM};
    color: #b8bcc8;
    display: flex;
    align-items: center;
    transition: all 0.3s ease;

    img {
      transition: all 0.3s ease;
      filter: brightness(0.8);
    }

    &:hover img {
      filter: brightness(1.2);
    }
  }

  a {
    color: #b8bcc8;
    text-decoration: none;
    transition: all 0.3s ease;
    position: relative;

    &:hover {
      color: #146ad3;
      text-decoration: none;
    }

    &::after {
      content: "";
      position: absolute;
      bottom: -2px;
      left: 0;
      width: 0;
      height: 1px;
      background: linear-gradient(90deg, #146ad3, #e8292e);
      transition: width 0.3s ease;
    }

    &:hover::after {
      width: 100%;
    }
  }

  @media (max-width: 768px) {
    padding: 40px 0 30px 0;

    .col-sm-3 {
      margin-bottom: 30px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    h5 {
      margin-bottom: 20px;
    }

    .logo {
      max-width: 150px;
      margin-bottom: 20px;
    }
  }
`;

export const CopyrightBar = styled.div`
  background: linear-gradient(90deg, #0a0d12 0%, #1a1f2e 50%, #0a0d12 100%);
  ${flexCenter};
  color: #8a8d9a;
  padding: 20px 0;
  border-top: 1px solid rgba(20, 106, 211, 0.1);
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100px;
    height: 1px;
    background: linear-gradient(90deg, transparent, #146ad3, transparent);
  }

  p {
    text-align: center;
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.5px;
  }

  @media (max-width: 768px) {
    padding: 15px 0;

    p {
      font-size: 13px;
      padding: 0 20px;
    }
  }
`;
